import dayjs, { Dayjs } from 'dayjs';
import { t } from 'i18next';

import { PaymentTerm } from '~hooks/usePaymentTerms/models';

// SelectInput has no empty value of its own, so the "no term" option carries one
export const NO_PAYMENT_TERM = '';

function formatPaymentTermLabel(name: string, dueDays: number) {
  return `${name} (${dueDays})`;
}

// A term dates the settlement from its creation day, which for a new one is today
export function getPaymentTermDueDate(term: PaymentTerm, createdAt?: Dayjs | null) {
  const creationDate = createdAt ? dayjs.tz(createdAt) : dayjs.tz();

  return creationDate.add(term.dueDays, 'day');
}

export function dueDateMatchesPaymentTerm(
  dueDate: Dayjs | null | undefined,
  term: PaymentTerm | undefined,
  createdAt?: Dayjs | null,
) {
  return Boolean(term && dueDate?.isSame(getPaymentTermDueDate(term, createdAt), 'day'));
}

interface PaymentTermOptionsInput {
  paymentTerms: PaymentTerm[];
  savedPaymentTermId: string;
  // keeps the saved term selectable until the term list has loaded
  savedPaymentTermSnapshot?: { name: string; dueDays: number };
}

export function buildPaymentTermOptions({
  paymentTerms,
  savedPaymentTermId,
  savedPaymentTermSnapshot,
}: PaymentTermOptionsInput) {
  const savedPaymentTermIsListed = paymentTerms.some(
    (term) => term.id === savedPaymentTermId,
  );

  return [
    { label: t('common.none'), value: NO_PAYMENT_TERM },
    // a deactivated term the settlement already carries still shows what it has
    ...paymentTerms
      .filter((term) => term.active || term.id === savedPaymentTermId)
      .map((term) => ({
        label: formatPaymentTermLabel(term.name, term.dueDays),
        value: term.id,
      })),
    ...(savedPaymentTermId && !savedPaymentTermIsListed && savedPaymentTermSnapshot
      ? [
          {
            label: formatPaymentTermLabel(
              savedPaymentTermSnapshot.name,
              savedPaymentTermSnapshot.dueDays,
            ),
            value: savedPaymentTermId,
          },
        ]
      : []),
  ];
}
